
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import SettingsThemeSection from "@/components/settings/SettingsThemeSection";
import SettingsTutorialSection from "@/components/settings/SettingsTutorialSection";
import SettingsDebugSection from "@/components/settings/SettingsDebugSection";
import { SettingsSafeAreaSection } from "@/components/settings/SettingsSafeAreaSection";
import { useAuth } from "@/context/auth/AuthContext";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { Button } from '@/components/ui/button';
import { getCurrentTrack, getVersionJsonUrl } from '@/services/app/app-update.service';
import { useUiPreferences } from '@/hooks/useUiPreferences';

const SettingsPage = () => {
  const navigate = useNavigate();
  const { user, isLoading, signOut } = useAuth();
  const { theme } = useThemeConfig();
  const { showVersionLink } = useUiPreferences();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const track = getCurrentTrack();
  const versionUrl = getVersionJsonUrl();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/login");
    }
  }, [isLoading, user, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-viewport-height" style={{
        backgroundColor: theme.backgroundColor || '#f1f0fb',
        color: theme.sectionTextColor || theme.textColor || '#000000'
      }}>
        Caricamento...
      </div>
    );
  }

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-viewport-height" style={{
      backgroundColor: theme.backgroundColor || '#f1f0fb',
      color: theme.textColor || '#000000'
    }}>
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="container max-w-lg py-2 px-4">
        <h1
          className="text-2xl font-bold mb-6"
          style={{ color: theme.sectionTitleColor }}
        >
          Impostazioni
          {showVersionLink && (
            <>
              {" "}(
              <a
                href={versionUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
                style={{ color: theme.sectionTitleColor }}
              >
                {track}
              </a>
              )
            </>
          )}
        </h1>

        {/* Sezione Tema */}
        <SettingsThemeSection />

        {/* Sezione Tutorial */}
        <SettingsTutorialSection />

        {/* Sezione Safe Area */}
        <SettingsSafeAreaSection />

        {/* Sezione Debug */}
        <SettingsDebugSection />

        {/* Logout */}
        <div className="pt-4">
          <Button
            variant="destructive"
            onClick={handleLogout}
            className="w-full"
            style={{
              borderRadius: theme.buttonBorderRadius,
              padding: theme.buttonPadding,
              fontWeight: theme.fontWeightNormal || '400'
            }}
          >
            Logout
          </Button>
        </div>
        <div className="h-10" />
      </main>
    </div>
  );
};

export default SettingsPage;
